import { useCallback, useEffect, useRef, useState } from 'react';

import generalEndpoints from '../../../../api/services/generalEndpoints';

export const useFetchCities = (config = {allUf: false}) => {
  const [loading, setLoading] = useState();
  const [cities, setCities] = useState([])
  const isMounted = useRef(true)

  const fetchAllCities = useCallback(async () => {
    setLoading(true);
    if (cities.length === 0) {
        try {
          const response = config.allUf ? await generalEndpoints.getCities() : await generalEndpoints.getCities('ba');
          if(response.status === 200) {
            if(isMounted.current) setCities(response.data)
          }
        } finally {
          setLoading(false);
        }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchAllCities().catch(console.error);
    return () => {
      isMounted.current = false;
    };
  }, [fetchAllCities]);

  return {
    loading,
    cities,
  };
};